
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import Select from 'react-select';
import { retrieveCheckinData, getView, gethotelcleaners, getMyLinkedhotels, getemployees } from '../dbconnector/connector'
import { getCookie } from '../dbconnector/checktoken'
// import './css/checkinpage.css';
//import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import { useState } from 'react';
import EmployeeSelection from '../customNodes/EmployeeSelection';
import HotelSelection from '../customNodes/HotelSelection';
import Button from 'react-bootstrap/Button';
import { setErrorMessage, clearMessage, setMessage } from '../tools/errorhandling';

//import hotelcss from './css/hotelhotellist.module.css';



const Constructcheckinpage = (props) => {
    const [zoekbalk, setZoekbalk] = useState('');
    const [employees, setEmployees] = useState([]);
    const [linkedcleaners, setlinkedcleaners] = useState({});
    const [getactiveEmployee, setGetactiveEmployees] = useState(true);
    const [getactiveHotels, setGetactiveHotels] = useState(true);
    const [selectedhotel, setSelectedhotel] = useState(null);
    var [state, setState] = useState(null);
    const navigate = useNavigate();
    const t = props.translation
    const [linkedhotels, setlinkedhotels] = useState([]);
    let checkinlist = "";
    const [loading, setLoading] = useState(true);
    const [optionArray, setoptionArray] = useState([]);
    const [selectedCleaner, setselectedCleaner] = useState(null);

    // retrieveCheckinData(Date.now()).then((result) => {
    //     if (result.errormessage) {
    //         setErrorMessage(result.errormessage)
    //     } else if (!checkinlist.count) {
    //         checkinlist = result;
    //         //console.log("checkinlist :", checkinlist)
    //         createcheckinlist(checkinlist.checkins, t);
    //     }
    // })

    const filterlist = async (navigate, t) => {
        try {
            document.getElementById("list").innerHTML = "";

            let list = checkinlist.checkins;
            let fields;
            let values;
            const date = document.getElementById("dateinput").value;
            ////console.log(selectedCleaner)
            const employeeid = selectedCleaner
            ////console.log(document.getElementById("hotelsList").value)
            const hotelid = document.getElementById("hotelsList").value
            ////console.log("date =", date)
            //TODO: Clean-up this code, is not the most efficient way, but it works

            if (date && employeeid !== null && Number(hotelid) !== -1) {
                // //console.log("a")
                fields = '["Date","EMP_ID","hotel_Id"]';
                values = `["${date}",${employeeid},${hotelid}]`;
            }
            if (date && employeeid !== null && Number(hotelid) === -1) {
                ////console.log("b")
                fields = '["Date","EMP_ID"]';
                values = `["${date}",${employeeid}]`;
            }
            if (date && employeeid === null && Number(hotelid) !== -1) {
                ////console.log("c")
                fields = '["Date","hotel_Id"]';
                values = `["${date}",${hotelid}]`;
            }
            if (date && employeeid === null && Number(hotelid) === -1) {
                ////console.log("d")
                fields = '["Date"]';
                values = `["${date}"]`;
            }
            if (!date && employeeid !== null && Number(hotelid) === -1) {
                ////console.log("e")
                fields = '["EMP_ID"]';
                values = `[${employeeid}]`;
            }
            if (!date && employeeid === null && Number(hotelid) !== -1) {
                ////console.log("f")
                fields = '["hotel_Id"]';
                values = `[${hotelid}]`;
            }
            if (!date && employeeid !== null && Number(hotelid) !== -1) {
                ////console.log("g")
                fields = '["EMP_ID","hotel_Id"]';
                values = `[${employeeid},${hotelid}]`;
            }
            if (!date && employeeid === null && Number(hotelid) === -1) {
                ////console.log("h")
                fields = null;
                values = null;
                setMessage("Sorry, deze opdracht kan ik niet uitvoeren. Minstens één van de filtercriteria moet ingevuld zijn")
            } else {
                //TODO: getview cannot handle null objects
                getView("checkinreport", fields, values).then(res => {
                    if (res.status === 200) {
                        res.json().then(body => {
                            if (body.length > 0) {
                                clearMessage();
                                createcheckinlist(body)
                            }
                            else { setMessage("Er zijn geen check-in gegevens gevonden met deze zoekgegevens") }
                        })
                    } else {
                        setErrorMessage(res.statusText)
                    }

                })
            }
        } catch (e) { setErrorMessage(t("error_filterfailed")) }
    }


    const createcheckinlist = (list, t) => {
        //createheaders()

        let divlist = document.getElementById("list")
        divlist.innerHTML = "";
        //create a list item for every element in the received array
        list.forEach((element, index) => {
            console.log(element)
            //create wrapper employeediv
            const employediv = document.createElement("div")
            divlist.appendChild(employediv)


            const EMP_ID_div = document.createElement("p")
            EMP_ID_div.innerText = element.nr_wkn
            EMP_ID_div.className = "gridrowheight"
            employediv.appendChild(EMP_ID_div)

            const name = document.createElement("p")
            employediv.appendChild(name)
            name.className = "gridrowheight"
            name.innerText = element.FullName
            const datewor = new Date(element.Date)
            const dateworked = document.createElement("p")
            employediv.appendChild(dateworked)
            dateworked.className = "gridrowheight"
            dateworked.innerText = datewor.toLocaleDateString()


            const dateTimein = new Date(element.loginDateTime)

            const timeIn = document.createElement("p");
            timeIn.innerText = dateTimein.toLocaleTimeString();
            timeIn.className = "gridrowheight"
            employediv.appendChild(timeIn);
            const timeOut = document.createElement("p");
            if (element.checkoutTime !== null) {
                const dateTimeout = new Date(element.checkoutTime)
                timeOut.innerText = dateTimeout.toLocaleTimeString();
            } else {
                timeOut.innerText = "NA"
            }

            timeOut.className = "gridrowheight"
            employediv.appendChild(timeOut);

            ////console.log(element)
            const hotel = document.createElement("p");
            hotel.innerText = element.hotel
            employediv.appendChild(hotel);
            hotel.className = "gridrowheight"




            ////console.log(element)
            const type = document.createElement("p");
            type.innerText = element.type
            employediv.appendChild(type);
            type.className = "gridrowheight"
            employediv.className = "tableheader"

            //dynamicaly add classname
            if (index % 2 === 0) {
                employediv.className = "linkVarient1 gridCheckInList"
            } else {
                employediv.className = "linkVarient2 gridCheckInList"
            }

        }
        );

    }
    //TODO: gethotelcleaners bevat niet de nr_wkn van de employee
    const GetHotelCleaners = async (HotelId, active) => {
        setoptionArray([])
        setselectedCleaner(null)
        setlinkedcleaners([])
        if (HotelId) {
            const res = await gethotelcleaners(HotelId, active);
            const data = await res.json();

            for (const cleaner of data.items) {
                //console.log("cleaner = " , data.items)
                setlinkedcleaners(prevState => { return { ...prevState, [cleaner.id]: { cleaner } } })
            }
        } else {

            const Employees = getemployees(active);
            Employees.then((list) => {
                if (list.status === 200) {
                    for (const cleaner of list.items) {
                        //console.log("cleaner" , list.items)
                        setlinkedcleaners(prevState => { return { ...prevState, [cleaner.id]: { cleaner } } })
                    }

                }
            })
        }
    }

    const setActiveHotel = (e) => {
        setGetactiveHotels(null)
        setGetactiveHotels(e.target.checked)

    }
    const GetActiveHotelCleaners = (e) => {
        setGetactiveEmployees(e.target.checked)
        GetHotelCleaners(selectedhotel, e.target.checked)
    }

    useEffect(() => {
        ////console.log(linkedcleaners)
        if (Object.keys(linkedcleaners).length > 0) {
            const options = Object.keys(linkedcleaners).map((key) => {
                const emp = linkedcleaners[key].cleaner;
                if (emp.nr_wkn)
                    return { value: key, label: `${emp.nr_wkn} - ${emp.achternaam}, ${emp.voornaam} ` };
                else
                    return { value: key, label: `${emp.achternaam}, ${emp.voornaam} ` };
            })
            setoptionArray(options)
        }
    }, [linkedcleaners]);
    //dop something after loading page
    useEffect(() => {
        GetHotelCleaners(selectedhotel, getactiveEmployee)
        // fetchData();
    }, [props.rights]);


    const getHotelEmployees = (e) => {
        setSelectedhotel(e.target.value)
        //console.log(e.target.value, "  " ,getactiveEmployee)
        GetHotelCleaners(e.target.value, getactiveEmployee)
    }
    const selectchange = (option) => {
        setselectedCleaner(option ? option.value : null);
    }

    function addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }
    return (

        <div id="main">
            <header>
                <div id="errordiv" className='error'></div>
                <div id="coverAllmessage" className="coverall">
                    <div id="messagediv" className='message'>
                        <div id="messagetext" className="MessageText"></div><br></br>
                        <center>
                            <div className='messageBoxes'>
                                <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={clearMessage}>{t("OK")}</Button>
                            </div></center>
                    </div></div>

            </header>
            <div id="filters" className="form" >
                <label className='formtitleContentBox'>{t("filterinstellingen")}</label>
                <br></br>
                <div className="contentbox">
                    <div className="formElement">
                        <label className='labelcolor'>
                            {t("day")}:
                        </label>
                        <input id="dateinput" type='Date' className='date' defaultValue={addDays(new Date(), 0).toLocaleDateString('en-CA')}></input>
                    </div>

                    <div className="formElement gridformidentity_4">
                        <label className='labelcolor '>
                            {t("Hotel")}:
                        </label>
                        <HotelSelection id="selectedhotel"
                            isDisabled={false}
                            active={getactiveHotels}
                            data={{ disabled: false, fieldname: "nr_afd", selectedhotel: null, handleitemchange: getHotelEmployees }} valueneeded="hotel_id" css='date'>

                        </HotelSelection>
                        <label className='labelcolor left'>
                            {t("Active")}:
                        </label>
                        <input type="checkbox" id="activeHotel" className="checkbox" name="approved" onChange={setActiveHotel} defaultChecked="true">
                        </input>
                    </div>

                    <div className="formElement gridformidentity_4">
                        <label className='labelcolor'>
                            {t("employee")}:
                        </label>

                        <Select
                            id="employeeList"
                            onChange={selectchange}
                            options={optionArray}
                            value={optionArray.find(opt => opt.value === selectedCleaner) || null}
                            placeholder={t('Kies een medewerker')}
                            isSearchable
                            className='employeecombolist'
                        />
                        <label className='labelcolor left'>
                            {t("Active")}:
                        </label>
                        <input type="checkbox" id="activeEmployee" className="checkbox" name="approved" onChange={GetActiveHotelCleaners} defaultChecked="true">
                        </input>
                    </div>

                    <div className="formElement">
                        <label className='labelcolor' />
                        <button className='buttoncontainer filterButton' type='button' id="filterbutton" onClick={() => filterlist(navigate, t)}>{t("filter")}</button>
                    </div>
                    <br></br>
                </div>
                <br></br>
                <div id="headertable" className="tableheader gridCheckInList"><p id="ID">{t('nr_wkn')}</p><p id="Fullname">{t('Fullname')}</p><p id="Date">{t('Date')}</p><p id="TimeIn">{t('Time in')}</p><p id="Timeout">{t('Time out')}</p>
                    <p id="Hotel">{t('Hotel')}</p> <p id="Type">{t('Type')}</p>
                </div>
                <div id="list" className="list">
                </div>
            </div>
        </div>
    )

}


export { Constructcheckinpage }